<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/custom-event-name-casing */
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  agents: { type: Array, default: () => [] },
});

defineEmits(['add-sector', 'remove-sector', 'logo-change']);

const contacts = defineModel({
  type: Array,
  required: true,
});

const SECTORS = [
  'administrativo',
  'financeiro',
  'comercial',
  'juridico',
  'locacao',
  'venda',
  'outro',
];
const inputClass =
  'w-full rounded-lais border border-lais-border px-3 py-2 text-[14px] bg-white';
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Setores">
    <div class="grid gap-3">
      <div
        v-for="(contact, index) in contacts"
        :key="index"
        class="grid gap-2 rounded-lais border border-lais-border-soft p-3"
      >
        <div class="grid gap-2 md:grid-cols-5">
          <select v-model="contact.sector" :class="inputClass">
            <option v-for="sector in SECTORS" :key="sector" :value="sector">
              {{ sector }}
            </option>
          </select>
          <input
            v-model="contact.label"
            placeholder="Nome exibido"
            :class="inputClass"
          />
          <input
            v-model="contact.whatsapp_phone"
            placeholder="WhatsApp"
            :class="inputClass"
          />
          <input
            v-model="contact.description"
            placeholder="Quando usar"
            :class="inputClass"
          />
          <div class="flex items-center justify-between gap-2">
            <label class="flex items-center gap-1 text-[12px]">
              <input v-model="contact.active" type="checkbox" /> Ativo
            </label>
            <button
              type="button"
              class="text-[12px] text-lais-ruby"
              @click="$emit('remove-sector', index)"
            >
              Remover
            </button>
          </div>
        </div>

        <label class="flex items-center gap-2 text-[13px]">
          <input v-model="contact.site_profile_enabled" type="checkbox" />
          Criar conta no site para o setor
        </label>

        <div
          v-if="contact.site_profile_enabled"
          class="grid gap-3 rounded-lais border border-lais-border-soft bg-white p-3 md:grid-cols-2"
        >
          <LaisField label="Nome de usuário">
            <input
              v-model="contact.site_username"
              placeholder="ex: vendas-zona-sul"
              :class="inputClass"
            />
          </LaisField>
          <LaisField label="Usuário responsável">
            <select v-model="contact.responsible_user_id" :class="inputClass">
              <option :value="null">Selecione</option>
              <option v-for="agent in agents" :key="agent.id" :value="agent.id">
                {{ agent.name }}
                <template v-if="agent.email"> ({{ agent.email }}) </template>
              </option>
            </select>
          </LaisField>
          <LaisField label="Bio" class="md:col-span-2">
            <textarea v-model="contact.site_bio" rows="3" :class="inputClass" />
          </LaisField>
          <LaisField label="Logo do setor" class="md:col-span-2">
            <div class="flex items-center gap-3">
              <img
                v-if="contact.site_logo"
                :src="contact.site_logo"
                alt="Logo do setor"
                class="size-14 rounded-lais border border-lais-border object-cover"
              />
              <input
                type="file"
                accept="image/*"
                class="text-[13px]"
                @change="$emit('logo-change', $event, contact)"
              />
            </div>
          </LaisField>
        </div>
      </div>
      <button
        type="button"
        class="text-[13px] font-semibold text-lais-primary"
        @click="$emit('add-sector')"
      >
        + Adicionar setor
      </button>
    </div>
  </LaisCard>
</template>
